import type { ConceptDef } from '../types';

export const identifyEmotion: ConceptDef = {
  kind: 'tileMatch',
  id: 'identify-emotion',
  label: 'Identify Emotion',
  category: 'Social',
  description: 'Hear an emotion; tap the matching face.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'happy', answer: '😀 happy' },
      { say: 'sad', answer: '😢 sad' },
      { say: 'angry', answer: '😡 angry' },
      { say: 'scared', answer: '😨 scared' },
      { say: 'surprised', answer: '😲 surprised' },
      { say: 'proud', answer: '🥳 proud' },
    ],
  },
};
